import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { mergeMap, catchError, of, map } from 'rxjs'
import {
  FETCH_QUERY_DETAILS,
  FETCH_QUERY_DETAILS_SUCCESS,
  UPDATE_QUERY_ACTION,
  UPDATE_QUERY_SUCCESS_ACTION,
  fetch_query_dashboard_data,
  fetch_query_dashboard_data_success,
  load_query_summary_action,
  load_query_summary_success_action,
  save_query_action,
  save_query_success_action
} from '../action/query.action'
import {
  route_to_action,
  show_display_id_after_created_action,
  show_success_msg_after_updation_action,
  show_error_action
} from '../action/common/common.action'
import { QueryService } from 'src/app/services/query/query.service'

@Injectable()
export class QueryEffects {
  constructor(private actions$: Actions, private queryService: QueryService) {}

  fetch_query_dashboard_data$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_query_dashboard_data),
      mergeMap((action) =>
        this.queryService.callDashboardApi(action.days, action.sortBy, action.sortOrder).pipe(
          mergeMap((response) => [fetch_query_dashboard_data_success(response)]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  save_query_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_query_action),
      mergeMap(({ query, files, routeTo }) =>
        this.queryService.callSaveApi(query, files).pipe(
          mergeMap((response) => [
            save_query_success_action({ query: response, routeTo }),
            route_to_action({ routeTo }),
            show_display_id_after_created_action({ moduleName: 'Query', displayId: response?.displayId })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_query_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_QUERY_DETAILS),
      mergeMap(({ id }) =>
        this.queryService.callQueryDetailsApi(id).pipe(
          mergeMap((query) => [FETCH_QUERY_DETAILS_SUCCESS({ query })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_query_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_QUERY_ACTION),
      mergeMap(({ query, id, files, routeTo }) =>
        this.queryService.callUpdateApi(query, id, files).pipe(
          mergeMap((query) => [
            UPDATE_QUERY_SUCCESS_ACTION({ query, routeTo }),
            route_to_action({ routeTo }),
            show_success_msg_after_updation_action({ moduleName: 'Query' })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
  load_query_summary_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_query_summary_action),
      mergeMap((data) =>
        this.queryService.invokeQuerySummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map((query) => load_query_summary_success_action({ query: query })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
